import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./Terms.module.css";
import { Link } from "react-router-dom";
import illustration from "../../assets/hero.png";

export default function Terms() {
  const { t } = useTranslation("footer");

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroText}>
          <h1>{t("terms.title")}</h1>
          <p className={styles.lead}>{t("terms.lead")}</p>
        </div>

        <figure className={styles.heroImageWrap} aria-hidden>
          <img src={illustration} alt="" className={styles.heroImage} />
        </figure>
      </header>

      <section className={styles.container}>
        <article className={styles.card}>
          <h2>{t("terms.whoTitle")}</h2>
          <p>{t("terms.whoText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.acceptanceTitle")}</h2>
          <p>{t("terms.acceptanceText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.servicesTitle")}</h2>
          <p>{t("terms.servicesText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.accountsTitle")}</h2>
          <p>{t("terms.accountsText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.meetingsTitle")}</h2>
          <p>{t("terms.meetingsText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.paymentsTitle")}</h2>
          <p>{t("terms.paymentsText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.propertyTitle")}</h2>
          <p>{t("terms.propertyText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.limitationTitle")}</h2>
          <p>{t("terms.limitationText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.privacyTitle")}</h2>
          <p>{t("terms.privacyText")}</p>
        </article>

        <article className={styles.card}>
          <h2>{t("terms.changesTitle")}</h2>
          <p>{t("terms.changesText")}</p>
        </article>

        <article className={styles.cardSmall}>
          <h3>{t("terms.contactTitle")}</h3>
          <p>
            {t("terms.contactText1")}
            <br />
            {t("terms.contactText2")}
            <br />
            {t("terms.contactText3")}
          </p>
        </article>
      </section>
    </main>
  );
}
